module.exports = __webpack_public_path__ + "img/logo.a67679aa.png";